<template>
  <div class="page-container">
    <div v-if="getAssets.images.finish.logo" class="logo-container">
      <img :src="getAssets.images.finish.logo" alt="logo" />
    </div>

    <div class="center-content">
      <h1 :style="{ color: getColor }" class="mb-3 text-center">Solicitação realizada com sucesso</h1>
      <h2>{{ getMessage }}</h2>

      <div class="action-button">
        <v-btn class="custom-button" :color="getColor" @click="goBack">Voltar para o início</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getMessage() {
      return this.removeAll
        ? 'Seus cadastro deixará de existir nos nossos sistemas muito em breve. Podemos ainda guardar informações suas em decorrência de outras leis financeiras.'
        : 'Sua solicitação será analisada com muito cuidado e você receberá uma resposta pelo endereço de e-mail informado.'
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle
    },
    getAssets() {
      return this.GET_ASSETS
    },
    getColor() {
      return this.getAssets.colors.finish.main || this.getAssets.colors.form.buttonBackground
    }
  },
  watch: {
    isIdle() {
      if (this.isIdle) this.goBack()
    }
  },
  mounted() {
    this.removeAll = this.$route.params.all
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/home' })
    }
  }
}
</script>

<style lang="scss">
.page-container {
  max-width: 1056px;
  margin: 0 auto;
  height: 100%;
  padding: 36px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .logo-container {
    max-width: 140px;
    height: 140px;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 100%;
    }
  }

  .center-content {
    height: calc(100% - 140px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  h1 {
    font-weight: 700;
    font-size: 28px;
  }

  h2 {
    color: #4b525a;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 48px;
    max-width: 590px;
    text-align: center;
  }
}

.action-button {
  .custom-button {
    text-transform: unset !important;
    letter-spacing: 0.02px !important;
    color: #fff;
    padding: 12px 32px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    width: 216px;
    height: 43px !important;
    box-shadow: none;
  }
}
</style>
